<template>
  <div class="icon-text">
    <Icon class="icon" :type="icon" width="22"/>
    <span class="text">{{text}}</span>
  </div>
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: 'IconText',
  components: {
    Icon
  },
  props: {
    icon: String,
    text: String,
  },
}
</script>

<style lang="scss" scoped>
.icon-text {
  display: flex;

  .icon {
    margin-right: 4px;
  }
}

</style>
